import { render, staticRenderFns } from "./PermissionsManagementForm.vue?vue&type=template&id=454b30d0&scoped=true&"
import script from "./PermissionsManagementForm.vue?vue&type=script&lang=js&"
export * from "./PermissionsManagementForm.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsManagementForm.vue?vue&type=style&index=0&id=454b30d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454b30d0",
  null
  
)

export default component.exports
import {QCardSection,QForm,QScrollArea,QInput,QSelect} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCardSection,QForm,QScrollArea,QInput,QSelect})
